import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { ref, computed } from 'vue';
import { followMember, unFollowMember } from '@/js/lib/api/member';
import { useMemberStore } from '@/js/lib/store/member';
import { useUserStore } from '@/js/lib/store/user';
import { loading } from '@/js/lib/ui';
import { signinSignup } from '@/js/lib/ui/signin-signup';
import SvgIcon from '@/js/components/molecules/SvgIcon.vue';
import HeartActiveIcon from '@/icon/vue/heart-active.svg';
import HeartFillIcon from '@/icon/vue/heart-fill.svg';


export default /*@__PURE__*/_defineComponent({
  __name: 'followButton',
  props: {
    memberId: {},
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const userStore = useUserStore();
const memberStore = useMemberStore();
const isLoading = ref(false);
const isFollowed = computed(() => memberStore.followedMemberIds.includes(props.memberId));
const follow = async () => {
  memberStore.addFollowedMemberId(props.memberId);
  await followMember({ memberId: props.memberId }).catch(() => {
    memberStore.removeFollowedMemberId(props.memberId);
  });

  window.dataLayer?.push({
    event: 'follow',
    event_category: 'kpi',
    event_label: 'shop',
  });
};
const unfollow = async () => {
  memberStore.removeFollowedMemberId(props.memberId);
  await unFollowMember({ memberId: props.memberId }).catch(() => {
    memberStore.addFollowedMemberId(props.memberId);
  });
};
const onClick = async () => {
  if (userStore.isAuthenticated) {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;
    await (isFollowed.value ? unfollow() : follow());
    isLoading.value = false;
  } else {
    signinSignup({
      next: window.location.href,
      callback: async () => {
        await loading({
          asyncFunc: async () => {
            follow();
            window.location.reload();
          },
          text: 'ログインしています',
        });
      },
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([_ctx.$style.button, isFollowed.value && _ctx.$style.isFollowed, _ctx.small && _ctx.$style.small]),
    onClick: onClick
  }, [
    (isFollowed.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode(SvgIcon, {
            svg: _unref(HeartFillIcon),
            class: _normalizeClass(_ctx.$style.heartIcon)
          }, null, 8, ["svg", "class"]),
          _cache[0] || (_cache[0] = _createTextVNode("お気に入りに追加済", -1))
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(SvgIcon, {
            svg: _unref(HeartActiveIcon),
            class: _normalizeClass(_ctx.$style.heartIcon)
          }, null, 8, ["svg", "class"]),
          _cache[1] || (_cache[1] = _createTextVNode("お気に入りショップに追加", -1))
        ]))
  ], 2))
}
}

})